import React from "react";

const Preloader = ({ hide }) => {
  return (
    <div className={`new-custom-loader-wrapper ${hide ? "hide" : ""}`}>
      <div className="new-custom-loader-preloader">
        <div className="new-custom-loader-logo-white"></div>
        <div className="new-custom-loader-logo-color"></div>
      </div>
    </div>
  );
};

export default Preloader;
